import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalAddEffectError extends FatalError {
  static override locales: Locales = {
    'en-US': '%s cannot be used outside constructor, please use %s',
    'zh-CN': '%s 不能在非构造函数中使用，请使用 %s',
    'zh-HK': '%s 不能在非構造函數中使用，請使用 %s'
  }

  override name = 'FatalAddEffectError' as const

  constructor(banMethod: string, useMethod: string) {
    super(banMethod, useMethod)
  }
}

export class FatalEffectHookError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Effect hooks cannot be called asynchronously',
    'zh-CN': '效果钩子不能被异步函数调用',
    'zh-HK': '效果鉤子不能被異步函數調用'
  }

  override name = 'FatalEffectHookError' as const

  constructor() {
    super()
  }
}
